<div class="fullcontainer pr-3">
  <div class='sheet'>
    <div class='titleContainer'>
      <h1 class='header'>Report - Sepa Jobs</h1>
    </div>

    <div class='row'>
      <div class='col-md-4'>
        <label>Start Date</label>
        <input type='date' [(ngModel)]="this.searchFilters.startDate" class='form-control' />
      </div>
      <div class='col-md-4'>
        <label>End Date</label>
        <input type='date' class='form-control' [(ngModel)]="this.searchFilters.endDate" />
      </div>
      <div class='col-md-4'>
        <label>Tip Site</label>
        <ng-select [(ngModel)]="this.searchFilters.tipSiteId" (change)='this.searchFilters.tipSiteId = $event;'>
          @for (item of this.accounts; track item) {
            <ng-option [value]='item.id'>{{ item.name }}</ng-option>
          }
        </ng-select>
      </div>
    </div>
    <br />
    <br />
    <button class='btn btn-primary' (click)='this.loadReport()'>Run Report</button>
    <hr />
    <button class='btn btn-secondary' (click)='exportToCSV()'>Export to CSV</button>
  </div>

  <div class='sheet'>
    @if (this.results.length > 0) {
      <div class='titleContainer'>
        <button class="btn btn-info" (click)="downloadInvoices()">Download Invoices</button>
        <h1 class='header'>Results</h1>
        <table class='table'>
          <thead>
            <th>Invoice Id</th>
            <th>Job Id</th>
            <th>Driver</th>
            <th>Vehicle</th>
            <th>Subcontractor</th>
            <th>Subcontractor Reg</th>
            <th></th>
          </thead>
          <tbody>
            @for (result of this.results; track result) {
              <tr>
                <td>{{ result.invoiceId }}</td>
                <td>{{ result.jobId }}</td>
                <td>{{ result.driver }}</td>
                <td>{{ result.vehicle }}</td>
                <td>{{ result.subcontractor }}</td>
                <td>{{ result.subcontractorReg }}</td>
                <td><button class='btn btn-warning' [routerLink]='"/job-signoff/land/view/" + result.jobId'>View job</button>
                <td></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
